<template>
    <div v-if="success" class="form-success animated text-center slideOutUp delay-5s">
        <div class="content">
            <h2>Uw aanvraag werd verzonden.</h2>
            <p>U kan binnen enkele ogenblikken een persoonlijke offerte terugvinden in uw mailbox.</p>
        </div>
    </div>
</template>

<script>
    export default
    {
        data() {
            return {
                success: false
            }
        },
        mounted() {
            this.$data.success = sessionStorage.getItem('flashMessage');
            sessionStorage.clear();
        }
    }
</script>

<style scoped lang="scss">
    .form-success{
        z-index: 999999 !important;
        position: fixed;
        width: 100%;
        height: 100vh;
        background-color: #575149;
        left: 0;
        right: 0;
        top: 0;
        overflow: hidden;
        animation-fill-mode: forwards;

        .content {
            border: 1px;
            position: absolute;
            height: 60px;
            line-height: 60px;
            left: 50%;
            top: 50%;
            -webkit-transform: translate(-50%, -50%);
            transform: translate(-50%, -50%);
            p {
                text-align: center;
                color: #d8cdb2;
            }
        }
    }

    @keyframes example {
        0%, 100% {
            margin-left: -200px
        }
        10%, 90% {
            margin-left: 0px
        }
    }
</style>